import { Routing } from '../Common/Routing'
import { ReactElement } from 'react'
import CommonContext from '../Common/CommonContext'
import { CustomerApp } from './CustomerApp'

const CustomerBookingflowApp = (): ReactElement => {
    return (
        <>
            <Routing>
                <CommonContext>
                    <CustomerApp />
                </CommonContext>
            </Routing>
        </>
    )
}

export { CustomerBookingflowApp }
